/**
 * This function is responsible for opening the given {@link link} in a new tab of the browser.
 */
export const openLinkInTab = (link: string) => window.open(link, "_blank");
